import { render, staticRenderFns } from "./newCooperationMall.vue?vue&type=template&id=721693f6&scoped=true"
import script from "./newCooperationMall.vue?vue&type=script&lang=js"
export * from "./newCooperationMall.vue?vue&type=script&lang=js"
import style0 from "./newCooperationMall.vue?vue&type=style&index=0&id=721693f6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721693f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('721693f6')) {
      api.createRecord('721693f6', component.options)
    } else {
      api.reload('721693f6', component.options)
    }
    module.hot.accept("./newCooperationMall.vue?vue&type=template&id=721693f6&scoped=true", function () {
      api.rerender('721693f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cooperationMall/newCooperationMall/newCooperationMall.vue"
export default component.exports